import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter010() {
  return <KbChapterPage slug="chapter-010" />;
}

(Chapter010 as unknown as { path: string }).path = "/theory-album/010";
